import { render, staticRenderFns } from "./WhatIf.vue?vue&type=template&id=644eeefe&scoped=true&"
import script from "./WhatIf.vue?vue&type=script&lang=js&"
export * from "./WhatIf.vue?vue&type=script&lang=js&"
import style0 from "./WhatIf.vue?vue&type=style&index=0&id=644eeefe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644eeefe",
  null
  
)

export default component.exports